module.exports = __webpack_public_path__ + "static/media/gifts_favors.3f2fb050.svg";